export default "__VITE_ASSET__B_uqm4kK__"